<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
    <input appInputDate formControlName="validFrom" [attr.max]="maxValidFrom">
  </app-input-group>
</form>

<app-calculation-form
  [form]="form"
  [rowHandler]="rowHandler">
</app-calculation-form>
